<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
          <BackLink />
          <Section :section="this.sectionId" />
        </div>
        <Form
          :error="error"
          :formId="id"
          :formErrorMessage="errorMessage"
          @submit="submitFormQuestion"
        >
          <CheckboxList
            :title="question"
            :hintText="hintText"
            :detailsTitle="detailsTitle"
            :detailsMessage="detailsMessage"
            :error="error"
            :errorMessage="errorMessage"
            :id="id"
          >
            <div v-for="(option, index) in options" :key="index">
              <span class="hint" v-if="option.separator">or</span>
              <div class="checkbox">
                <input
                  class="checkbox__input"
                  :id="'check'+index"
                  name="check"
                  type="checkbox"
                  :value="{id: option.id, response: option.label}"
                  @change="checkAnswers"
                  v-model="form.answer"
                />
                <label class="label checkbox__label" :for="'check'+index">{{option.label}}</label>
              </div>
            </div>
          </CheckboxList>
        </Form>
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from "../shared";

export default {
  name: "home",
  props: {
    title: String
  },
  data() {
    return {
      id: "",
      sectionId: null,
      question: "",
      hintText: "",
      error: false,
      errorMessage: "All fields are required",
      detailsTitle: "",
      detailsMessage: "",
      name: "",
      nextUrl: "",
      noSelectionUrl: "",
      options: [],
      form: {
        answer: []
      }
    };
  },
  created() {
    this.loadQuestion();
  },
  mounted() {
    this.loadAnswer();
  },
  methods: {
    changeValue: function(newValue) {
      this.form.answer = {
        id: this.options[newValue].id,
        resposne: this.options[newValue].response
      };
      this.nextUrl = this.options[newValue].destination;
      this.form.label = this.options[newValue].label;
    },
    submitForm() {
      if (this.validateResponses(this.options)) {
        this.logResponse();
        this.isValid();
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: this.nextUrl.toLowerCase() });
            }
      } else {
        this.isNotValid();
      }
    },
    isValid() {
      this.error = false;
      this.errorMessage = "";
    },
    isNotValid() {
      this.error = true;
      setTimeout(() => {
        document.querySelector(".error-summary__link").focus();
      }, 0);
    },
    checkAnswers() {
      return this.validateResponses(this.options)
        ? this.isValid()
        : this.isNotValid();
    },
    submitFormQuestion() {
      this.submitForm(this.form);
    },
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.id = currentQuestion.id;
      this.sectionId = currentQuestion.sectionId;
      this.question = currentQuestion.question;
      this.hintText = currentQuestion.hintText;
      this.name = currentQuestion.responseId;
      this.options = currentQuestion.options;
      this.errorMessage = currentQuestion.errorMessage;
      this.detailsTitle = currentQuestion.detailsTitle;
      this.detailsMessage = currentQuestion.detailsMessage;
      this.noSelectionUrl = currentQuestion.noSelectionDestination;
    },
    validateResponses(options) {
      let hasIS = false;
      let hasESA = false;
      let hasJSA = false;
      let hasPC = false;
      let hasTC = false;
      let removeAll = false;
      let destination = "";

      if (document.getElementById("check0").checked) {
        hasIS = true;
        destination = options[0].destination;
      } else {
        var index0 = dataService.findIndex(this.form.answer, 0);
        if (index0 > -1) {
          this.form.answer.splice(index0, 1);
        }
      }
      if (document.getElementById("check2").checked) {
        hasESA = true;
        if (!hasIS) {
          destination = options[2].destination;
        }
      } else {
        var index2 = dataService.findIndex(this.form.answer, 2);
        if (index2 > -1) {
          this.form.answer.splice(index2, 1);
        }
      }
      if (document.getElementById("check3").checked) {
        hasJSA = true;
        if (!hasIS) {
          destination = options[3].destination;
        }
      } else {
        var index3 = dataService.findIndex(this.form.answer, 3);
        if (index3 > -1) {
          this.form.answer.splice(index3, 1);
        }
      }
      if (document.getElementById("check4").checked) {
        hasPC = true;
        if (!hasIS && !hasESA && !hasJSA) {
          destination = options[4].destination;
        }
      } else {
        var index4 = dataService.findIndex(this.form.answer, 4);
        if (index4 > -1) {
          this.form.answer.splice(index4, 1);
        }
      }
      if (document.getElementById("check1").checked) {
        hasTC = true;
        if (!hasIS && !hasESA && !hasJSA && !hasPC) {
          destination = options[1].destination;
        }
      } else {
        var index1 = dataService.findIndex(this.form.answer, 1);
        if (index1 > -1) {
          this.form.answer.splice(index1, 1);
        }
      }
      if ((this.form.answer[0] && this.form.answer[0].id == 5) && (hasIS || hasESA || hasJSA || hasPC || hasTC)) {
        this.form.answer.shift();
        document.getElementById("check5").checked = false;
      } else {
        if (document.getElementById("check5").checked) {
          destination = options[5].destination;
          hasIS = false;
          hasESA = false;
          hasJSA = false;
          hasPC = false;
          removeAll = true;
        }
      }

      if (removeAll) {
        this.form.answer = this.form.answer.slice(-1);
        document.getElementById("check0").checked = false;
        document.getElementById("check1").checked = false;
        document.getElementById("check2").checked = false;
        document.getElementById("check3").checked = false;
        document.getElementById("check4").checked = false;
      }

      this.nextUrl = destination;
      if (this.nextUrl == "") {
        this.errorMessage = "Select which benefits you get or select ‘no’.";
        return false;
      } else if (hasESA && hasJSA) {
        this.errorMessage =
          "ESA and JSA cannot be claimed together. Select which benefit you get or uncheck all responses.";
        return false;
      } else {
        return true;
      }
    },
    loadAnswer() {
      let answers = [];
      let previousResponse = dataService.wasAnsweredBefore(this.id);
      if (previousResponse) {
        previousResponse.responses.forEach(function(r) {
          setTimeout(() => {
            document.getElementById("check" + r.responseId).checked = true;
          }, 300);
          answers.push({ id: r.responseId, response: r.response.substring(30) });
        });
      }
      this.form.answer = answers;
    },
    logResponse() {
      let response = {
        id: this.id,
        questionType: "Checkbox",
        responses: []
      };
      this.form.answer.forEach(function(selection) {
        let r = {
          responseId: selection.id,
          response: "You have declared you receive " + selection.response
        };
        response.responses.push(r);
      });
      dataService.logResponse(response);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>